"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrialBookingFieldMapping = getTrialBookingFieldMapping;
exports.getUniqueTrialBookingDays = getUniqueTrialBookingDays;
exports.readTrialBookingLocalStorage = readTrialBookingLocalStorage;
exports.fillTrialBookingHiddenFields = fillTrialBookingHiddenFields;
exports.slotToDetails = slotToDetails;
exports.createSelectedTimeslotContainer = createSelectedTimeslotContainer;
exports.createTrialBookingData = createTrialBookingData;
exports.createMagiclineTrialBookingData = createMagiclineTrialBookingData;
exports.addInitialPlaceholderTags = addInitialPlaceholderTags;
exports.replaceTrialBookingPlaceholdersTimeslots = replaceTrialBookingPlaceholdersTimeslots;
exports.getTrialBookingBaseStyles = getTrialBookingBaseStyles;
exports.getCurrentDate = getCurrentDate;
exports.formatUserLocal = formatUserLocal;
exports.isMobile = isMobile;
exports.isMobileScreenSize = isMobileScreenSize;
var cash_dom_1 = __importDefault(require("cash-dom"));
var input_output_helper_const_1 = require("@src/const/input-output-helper.const");
var input_mapping_const_1 = require("@const/input.mapping.const");
var input_mapping_presets_1 = require("@src/const/input.mapping.presets");
function getTrialBookingFieldMapping($container) {
    var mapping = __assign({}, input_mapping_const_1._TrialBookingMapping);
    var genderElem = $container.find('*[data-get="' + input_mapping_const_1._TrialBookingMapping.gender.uid + '"]');
    if (genderElem.length > 0 && genderElem[0].tagName.toLowerCase() === 'select') {
        mapping.gender = input_mapping_presets_1.inputMapping.genderDropdown;
    }
    return mapping;
}
function getUniqueTrialBookingDays(trialBookings) {
    var days = trialBookings.slots.map(function (slot) { return slot.startDateTime.split('T')[0]; });
    var daysUnique = days.filter(function (value, index, array) { return array.indexOf(value) === index; });
    return daysUnique.map(function (x) { return new Date(x); });
}
function readTrialBookingLocalStorage($container, mapping) {
    if (!(0, input_output_helper_const_1._ShouldPrefillFromLocalStorage)())
        return;
    cash_dom_1.default.each(mapping, function (key, value) {
        var selector = "[data-set=\"".concat(value.uid, "\"]");
        var storedValue = localStorage.getItem(value.uid) || '';
        if (selector.length > 0) {
            (0, cash_dom_1.default)(selector).val(storedValue);
        }
        if (key === 'dateOfBirth' && storedValue.length > 0 && storedValue.split('-').length === 3) {
            var split = storedValue.split('-');
            $container.find('*[data-get="' + input_mapping_const_1._BirthdayForm.dayOfBirth.uid + '"]').val(split[2]);
            $container.find('*[data-get="' + input_mapping_const_1._BirthdayForm.monthOfBirth.uid + '"]').val(split[1]);
            $container.find('*[data-get="' + input_mapping_const_1._BirthdayForm.yearOfBirth.uid + '"]').val(split[0]);
        }
    });
}
function fillTrialBookingHiddenFields($container, slot) {
    var selectedSlotStartField = $container.find('*[data-get="selectedSlotStartTime"]');
    if (selectedSlotStartField.length) {
        selectedSlotStartField.val(formatUserLocal(slot.startDateTime));
    }
    var selectedSlotEndField = $container.find('*[data-get="selectedSlotEndTime"]');
    if (selectedSlotEndField.length) {
        selectedSlotEndField.val(formatUserLocal(slot.endDateTime));
    }
}
function slotToDetails(selectedSlot) {
    var startDateTime = new Date(selectedSlot.startDateTime);
    var endDateTime = new Date(selectedSlot.endDateTime);
    // Calculate the duration in minutes
    var totalMinutes = Math.round((endDateTime.getTime() - startDateTime.getTime()) / (1000 * 60));
    // Calculate hours and remaining minutes
    var hours = Math.floor(totalMinutes / 60);
    var minutes = totalMinutes % 60;
    // Format the duration string
    var duration;
    if (hours > 0) {
        if (minutes > 0) {
            duration = "".concat(hours, " Std. ").concat(minutes, " Min");
        }
        else {
            if (hours > 1) {
                duration = "".concat(hours, " Stunden");
            }
            else {
                duration = "".concat(hours, " Stunde");
            }
        }
    }
    else {
        duration = "".concat(minutes, " Min");
    }
    // Format the date and time
    var options = {
        weekday: 'long', // "long" | "short" | "narrow"
        year: 'numeric', // "numeric" | "2-digit"
        month: 'long', // "long" | "short" | "narrow" | "numeric" | "2-digit"
        day: 'numeric', // "numeric" | "2-digit"
    };
    var formattedStartTime = startDateTime.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
    });
    var formattedEndTime = endDateTime.toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
    });
    var formattedDate = startDateTime.toLocaleDateString(undefined, options);
    // Get the timezone
    var timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var formattedStartDateTime = formatUserLocal(selectedSlot.startDateTime);
    return {
        duration: duration,
        formattedStartTime: formattedStartTime,
        formattedStartDateTime: formattedStartDateTime,
        formattedEndTime: formattedEndTime,
        formattedDate: formattedDate,
        timezone: timezone,
    };
}
function createSelectedTimeslotContainer(selectedSlot) {
    var slotDetails = slotToDetails(selectedSlot);
    return (0, cash_dom_1.default)("\n       <div style=\"margin: 5px;\">\n         <div style=\"display:flex; align-items: center; margin: 5px;\">\n           <ci-icon icon=\"clock\" size=\"30px\" style=\"margin-right: 5px;\"></ci-icon>\n           <span>".concat(slotDetails.duration, "</span>\n         </div>\n         <div style=\"display:flex; align-items: center; margin: 5px;\">\n           <ci-icon icon=\"calendar\" size=\"30px\" style=\"margin-right: 5px;\"></ci-icon>\n           <span>").concat(slotDetails.formattedStartTime, " - ").concat(slotDetails.formattedEndTime, ", ").concat(slotDetails.formattedDate, "</span>\n         </div>\n         <div style=\"display:flex; align-items: center; margin: 5px;\">\n           <ci-icon icon=\"earth\" size=\"30px\" style=\"margin-right: 5px;\"></ci-icon>\n           <span>").concat(slotDetails.timezone, "</span>\n         </div>\n       <div>"));
}
function createTrialBookingData(selectedSlot, // yond has no slots, they are full day
studioId, customerData, config, studioDropdown, selectedDay, extraData) {
    var _a, _b, _c, _d;
    if (extraData === void 0) { extraData = {}; }
    var bookingData = createMagiclineTrialBookingData(selectedSlot, studioId, customerData, config, extraData);
    if (config.get.technologyType === 'yond') {
        var yondStudioToContractMapping = (_b = (_a = config.get) === null || _a === void 0 ? void 0 : _a.yond) === null || _b === void 0 ? void 0 : _b.studioLocationMapping;
        if (!yondStudioToContractMapping) {
            console.warn('Yond trial booking needs a studio location mapping');
            throw 'Yond trial booking needs a studio location mapping';
        }
        var selectedStudio = studioDropdown.studios.find(function (s) { var _a; return ((_a = s.yondStudioOid) === null || _a === void 0 ? void 0 : _a.toString()) === (studioId === null || studioId === void 0 ? void 0 : studioId.toString()); });
        var possibleContractIds_1 = yondStudioToContractMapping[selectedStudio.id];
        var selectedOffering = (_c = studioDropdown.trialBookingContracts.filter(function (cont) {
            return possibleContractIds_1.includes(cont.yondTerifOid) &&
                cont.terms.filter(function (term) { return term.termUnit === 'DAY' && term.termValue === 1; }).length > 0;
        })) === null || _c === void 0 ? void 0 : _c[0];
        console.log('selected studio id', studioId, 'selected studio', selectedStudio, 'possible contracts', possibleContractIds_1, 'selectedOffering', selectedOffering);
        bookingData.provider = {
            name: 'yond',
            homeFacilityOid: selectedStudio.yondStudioOid,
            legalEntityOid: selectedStudio.yondLegalEntitiyOid,
            tariffVariantOid: (_d = selectedOffering === null || selectedOffering === void 0 ? void 0 : selectedOffering.id) === null || _d === void 0 ? void 0 : _d.toString(),
            contractStartDate: selectedDay,
        };
    }
    return bookingData;
}
function createMagiclineTrialBookingData(selectedSlot, studioId, customerData, config, extraData) {
    var _a, _b, _c, _d;
    if (extraData === void 0) { extraData = {}; }
    var noteStorage = JSON.parse(localStorage.getItem('note') || '{}');
    var note = Object.entries(noteStorage)
        .map(function (_a) {
        var key = _a[0], val = _a[1];
        return "".concat(key, ": ").concat(val);
    })
        .join(', ');
    var bookingData = {
        tenantKey: config.get.tenantKey,
        studioId: studioId.toString(),
        startDateTime: (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.startDateTime) ? new Date(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.startDateTime).getTime() : undefined,
        endDateTime: (selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.endDateTime) ? new Date(selectedSlot === null || selectedSlot === void 0 ? void 0 : selectedSlot.endDateTime).getTime() : undefined,
        email: customerData.email,
        givenName: customerData.firstname,
        familyName: customerData.lastname,
        source: 'fms',
        dateOfBirth: ((_a = customerData.dateOfBirth) === null || _a === void 0 ? void 0 : _a.length) ? customerData.dateOfBirth : undefined,
        gender: ((_b = customerData.gender) === null || _b === void 0 ? void 0 : _b.length) ? customerData.gender : undefined,
        phone: ((_c = customerData.telephone_mobile) === null || _c === void 0 ? void 0 : _c.length) ? customerData.telephone_mobile : undefined,
        note: note,
        participants: extraData.participants,
        participantData: ((_d = extraData.participantData) === null || _d === void 0 ? void 0 : _d.length) ? extraData.participantData : undefined,
    };
    return bookingData;
}
// convert {{trialSlotDuration}} to "data-placeholder-trial-slot-duration"
function formatPlaceholder(str) {
    return str
        .replace(/\{/g, '')
        .replace(/\}/g, '')
        .replace(/[A-Z]/g, function (letter) { return "-".concat(letter.toLowerCase()); });
}
function createPlaceholderSpan(key, value) {
    var dataTag = 'data-placeholder-' + formatPlaceholder(key) + '="true"';
    var elem = (0, cash_dom_1.default)('<span style="display:inline;" ' + dataTag + '></span>');
    elem.text(value);
    return elem;
}
function getPlaceholderMapping(selectedSlot) {
    var _a, _b, _c, _d, _e, _f;
    var slotDetails = selectedSlot ? slotToDetails(selectedSlot) : {};
    return [
        { key: '{{trialSlotDuration}}', value: (_a = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.duration) !== null && _a !== void 0 ? _a : '' },
        { key: '{{trialSlotStartTime}}', value: (_b = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.formattedStartTime) !== null && _b !== void 0 ? _b : '' },
        { key: '{{trialSlotStartDateTime}}', value: (_c = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.formattedStartDateTime) !== null && _c !== void 0 ? _c : '' },
        { key: '{{trialSlotEndTime}}', value: (_d = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.formattedEndTime) !== null && _d !== void 0 ? _d : '' },
        { key: '{{trialSlotDate}}', value: (_e = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.formattedDate) !== null && _e !== void 0 ? _e : '' },
        { key: '{{trialSlotTimezone}}', value: (_f = slotDetails === null || slotDetails === void 0 ? void 0 : slotDetails.timezone) !== null && _f !== void 0 ? _f : '' },
    ];
}
function addInitialPlaceholderTags($container) {
    var elements = $container.find('*[data-get="trialbookingPlaceholder"]');
    var esc = function (s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); };
    var mappings = getPlaceholderMapping();
    elements.each(function () {
        var content = (0, cash_dom_1.default)(this).html();
        var originalContent = content;
        mappings.forEach(function (m) {
            var regex = new RegExp(esc(m.key), 'g');
            if (regex.test(content)) {
                var generatedElem = createPlaceholderSpan(m.key, m.value);
                content = content.replace(regex, generatedElem.prop('outerHTML'));
            }
        });
        if (content !== originalContent)
            (0, cash_dom_1.default)(this).html(content);
    });
}
function replaceTrialBookingPlaceholdersTimeslots($container, selectedSlot) {
    var mappings = getPlaceholderMapping(selectedSlot);
    mappings.forEach(function (m) {
        var dataTag = formatPlaceholder(m.key);
        $container.find("*[data-placeholder-".concat(dataTag, "=\"true\"]")).text(m.value);
    });
}
function getTrialBookingBaseStyles() {
    var customStyles = "\n    .fittec-trial-booking-slot-wrapper {\n      border:1px solid rgb(255, 137, 80); \n      margin: 5px; \n      border-radius: 5px; \n      padding: 5px;\n    }\n    .fittec-trial-booking-slot-text {\n        color: rgb(255, 137, 80);\n        font-weight: 700;\n    }\n    .fittec-trial-booking-slot-wrapper-selected {\n      \n    }\n    .fittec-trial-booking-slot-text-selected {\n        border-width: 3px; \n    }\n  ";
    // Create a <style> element
    var styleElement = (0, cash_dom_1.default)('<style></style>');
    // Add the CSS to the <style> element
    styleElement.text(customStyles);
    return styleElement;
}
function getCurrentDate() {
    var currentDate = new Date();
    return currentDate.toISOString().split('T')[0];
}
function formatUserLocal(iso) {
    var tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    var d = new Date(iso);
    var parts = new Intl.DateTimeFormat('de-DE', {
        timeZone: tz,
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZoneName: 'short',
    })
        .formatToParts(d)
        .reduce(function (acc, p) {
        acc[p.type] = p.value;
        return acc;
    }, {});
    var z = parts.timeZoneName || tz; // e.g., "MESZ" / "MEZ" / "GMT+2"
    return "".concat(parts.day, ".").concat(parts.month, ".").concat(parts.year, " ").concat(parts.hour, ":").concat(parts.minute, " Uhr (").concat(z, ")");
}
function isMobile() {
    var regex = /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
}
function isMobileScreenSize() {
    var minWidth = 768; // Minimum width for desktop devices
    return window.innerWidth < minWidth || screen.width < minWidth;
}
